import { render, staticRenderFns } from "./ModalDeleteConfirm.vue?vue&type=template&id=9b606462&scoped=true&"
import script from "./ModalDeleteConfirm.vue?vue&type=script&lang=ts&"
export * from "./ModalDeleteConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalDeleteConfirm.vue?vue&type=style&index=0&id=9b606462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b606462",
  null
  
)

export default component.exports